import React from 'react';
import {Container, Button, Alert} from 'react-bootstrap';
import {useAuth} from '../auth/auth-context';
import {createBillingPortalSession} from './billing';

export default function BannedPage(): React.JSX.Element {
  const {logout} = useAuth();

  return (
    <Container className='my-5'>
      <Alert variant='danger'>
        <h1>Account disabled</h1>
        <p>
          Your account has been banned and access to the application has been
          disabled.
        </p>
      </Alert>
      <div className='d-flex gap-2'>
        <Button
          variant='outline-primary'
          onClick={() => {
            void createBillingPortalSession();
          }}
        >
          Payment Portal
        </Button>
        <Button
          variant='primary'
          onClick={() => {
            void logout();
          }}
        >
          Logout
        </Button>
      </div>
    </Container>
  );
}
